var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{attrs:{"lg4":""}},[_c('v-card',{attrs:{"tile":""}},[_c('v-card-actions',[_c('UploadBtn',{attrs:{"label":"Choisir","callBack":_vm.onFile}})],1),_c('v-card-media',[_c('img',{attrs:{"src":_vm.imageUrl}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }